export default __webpack_public_path__ + "static/recent-work-1-2d3027019dfca977b703f7804bda2da0.png";